import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menusoporte',
  templateUrl: './menusoporte.component.html',
  styleUrls: ['./menusoporte.component.scss']
})
export class MenusoporteComponent implements OnInit {

  constructor(public router:Router) { }

  ngOnInit() {
    if(localStorage.getItem("garoce")=="1"){
      this.garoce=true;   
    }else{
      this.garoce=false;   
    }
  }
  garoce=false;
  soporte(){
    this.router.navigate(['/ticket']);
  }
  soporteticket(){
    this.router.navigate(['/atenderticket']);
  }
}
